'use es6';

import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { FILTER_TYPES_OTHER, mapAcad021Categories, mapSoftwareFiltersWithAll } from '../constants/TopFilterConstants';
import UsageTracker from '../utils/UsageTracker';
import { useSearchParamSingleSelect } from '../hooks/searchParamHooks';
import styled from 'styled-components';
import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const CategoryButton = styled(UIButton).withConfig({
  displayName: "CategoryGroupDropdown__CategoryButton",
  componentId: "arsl2d-0"
})(["-webkit-font-smoothing:auto !important;font-weight:400 !important;@media screen and ", "{width:auto !important;font-weight:500 !important;}"], device.mobile);
const CategoryGroupDropdown = ({
  selectedCategory,
  selectedGroup,
  filterType
}) => {
  const [__, setCatalogFilter] = useSearchParamSingleSelect();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const categories = useSelector(state => state.filters.get('subCategories'));
  const tools = useSelector(state => state.filters.get('hsSoftwareFilters'));
  const groupCategories = filterType === FILTER_TYPES_OTHER.CATEGORIES ? mapAcad021Categories(categories).get(selectedGroup) : mapSoftwareFiltersWithAll(tools).get(selectedGroup);
  const trackFilterSelect = selectedOption => {
    UsageTracker.track('filterInteraction', {
      action: 'filter-selected',
      value: selectedOption,
      key: filterType,
      isDropdown: true
    });
  };
  const onClickOption = selectedOption => {
    setCatalogFilter(filterType, selectedOption);
    trackFilterSelect(selectedOption);
  };
  const getSelectedCategory = () => {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filterType}.${selectedCategory}`
    });
  };
  const getDropdownOptions = () => {
    return groupCategories.map(cat => /*#__PURE__*/_jsx(UIButton, {
      onClick: () => {
        onClickOption(cat);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${cat}`
      })
    }, cat));
  };
  return groupCategories && groupCategories.size > 0 ? /*#__PURE__*/_jsx(UIDropdown, {
    Button: CategoryButton,
    arrowSize: "none",
    buttonText: getSelectedCategory(),
    buttonUse: !isMobile ? 'link-on-dark' : 'link',
    children: /*#__PURE__*/_jsx(UIList, {
      children: getDropdownOptions()
    })
  }) : getSelectedCategory();
};
CategoryGroupDropdown.propTypes = {
  filterType: PropTypes.string,
  selectedCategory: PropTypes.string,
  selectedGroup: PropTypes.string
};
export default CategoryGroupDropdown;